import type ModalConversationInterceptorService from '../../modals/modal-conversation-interceptor.service';

export class PaymentInterceptorRegistrar {

    constructor(private modalConversationInterceptor: ModalConversationInterceptorService) {
    }

    public register() {
        this.modalConversationInterceptor.registerPaymentExceptionHandler('UserBalanceIsNotSufficientException');
    }
}